import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "./GlobalCursor.css";

export default function GlobalCursor() {
  const [mouse, setMouse] = useState({
    x: window.innerWidth / 2,
    y: window.innerHeight / 2,
  });

  useEffect(() => {
    const handleMove = (e) => {
      setMouse({
        x: e.clientX,
        y: e.clientY,
      });
    };

    window.addEventListener("mousemove", handleMove);

    return () => {
      window.removeEventListener("mousemove", handleMove);
    };
  }, []);

  return (
    <>
      {/* Large Spotlight */}
      <motion.div
        className="cursor-spotlight"
        animate={{
          x: mouse.x - 250,
          y: mouse.y - 250,
        }}
        transition={{
          type: "spring",
          stiffness: 150,
          damping: 20,
        }}
      />

      {/* Medium Glow */}
      <motion.div
        className="cursor-glow"
        animate={{
          x: mouse.x - 100,
          y: mouse.y - 100,
        }}
        transition={{
          type: "spring",
          stiffness: 300,
          damping: 25,
        }}
      />

      {/* Cursor Dot */}
      <motion.div
        className="cursor-dot"
        animate={{
          x: mouse.x - 4,
          y: mouse.y - 4,
        }}
        transition={{
          type: "spring",
          stiffness: 1000,
          damping: 40,
        }}
      />
    </>
  );
}